<template>
  <div class="ma-0">
    <AllOperationsDialogs ref="allOps" />
    <AdjustCCAndProduct ref="adjustCCAndProductDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="showRowDetails"
      :limits="[5, 10, 20, 50, 100, 200]"
      rememberLastClick
    />
  </div>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import AllOperationsDialogs from '../../clients/operations/AllOperationsDialogs.vue'
import AdjustCCAndProduct from '../../clients/operations/AdjustCCAndProduct.vue'
import { translateType } from '@/models/client-history.js'
import EditStore from './EditStore.js'
import { ClientHistory, go } from '@/models'

export default {
  components: {
    GenericReport,
    AllOperationsDialogs,
    AdjustCCAndProduct
  },
  data() {
    return {
      reportSpec: {
        code: 'ccClientHistory',
        title: 'Históricos lançados',
        // apiBase: '/history',
        filters: [
          {
            type: 'Combo',
            prefix: 'types',
            noSuffix: true,
            label: 'Tipo de Registro',
            strings: 'tipo;o',
            icon: 'mdi-tune',
            types: 'grouped-items',
            items: [
              { id: 'install', name: 'Instalação' },
              { id: 'remove', name: 'Retirada' },
              { id: 'intervention', name: 'Intervenção' }
            ]
          },

          {
            type: 'Switch',
            label: 'Mostrar cancelados',
            prefix: 'includeInactive',
            noSuffix: true,
            defVal: false
          }
        ]
      },
      adapterSpec: {
        defaultSortable: false,
        columns: [
          { t: 'ID|', d: 'uid', w: 100, color: '#cccccc' },
          { t: 'Item|', d: 'productItem.label' },
          { t: 'Produto|', d: 'productType.alias', selectable: true },
          { t: 'Veículo', d: 'vehicle.code' },
          { t: 'Cód. Aux.', d: 'vehicle.extraCode', selectable: true },
          { t: 'Org', d: 'org.label', selectable: true },
          {
            t: 'Data/hora',
            d: 'timestamp',
            dataType: 'date',
            format: 'DD/MM/YYYY HH:mm'
          },
          {
            t: 'Tipo',
            d: (row) =>
              translateType({ type: 'installation', subType: row.type })
          },
          { t: 'Técnico', d: 'technician.name', selectable: true },
          { t: 'Login', d: 'login' },
          { t: 'Comentários', d: 'comments', selectable: true },
          {
            t: 'Erro',
            d: (row) => row.errors && row.errors.join(','),
            selectable: true
          }
        ],
        rowExtraFieldsFn: ({ extraFields, row }) => {
          extraFields.historyType = row.type
          extraFields.historySubType = row.subType
          extraFields.clientId = row.clientId
        },
        rowStyleFn: ({ row }) => {
          if (row.errors && row.errors.length > 0)
            return { bgColor: '#ff0000', color: '#ffffff' }
          if (row.subType == 'remove') return { color: '#ff0000' }
          if (row.subType == 'intervention') return { color: '#ff0000' }
        }
      },
      selectedIds: []
    }
  },
  computed: {
    costCenterId() {
      return EditStore.row.id
    }
  },
  watch: {
    'EditStore.row'() {
      this.reload()
    },
    'EditStore.currentTab'(x) {
      if (x == 'lancamentos') this.reload()
    },
    showInactive() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.$refs.report.reload())
    },

    async fetchData(opts) {
      return await go.get('/multiproduct/cost-center/rows', {
        costCenterIds: this.costCenterId,
        offset: opts.offset,
        limit: opts.limit,
        types: opts.types,
        includeInactive: opts.includeInactive
      })
    },

    async showRowDetails({ row }) {
      let res = await this.$refs.allOps.startEdit(row)
      if (res === 'RELOAD') this.$refs.report.reload()
    }
  }
}
</script>

<style></style>
